// extracted by mini-css-extract-plugin
export default {"body":"business-modal_body__3ClW-","title":"business-modal_title__1g-7h","img":"business-modal_img__NG08h"};